import { useDispatch, useSelector } from 'react-redux';

import {
  getArtifactsState,
  setArtifactsList,
  setSuggestedMentors,
  setSummarization,
  toggleArtifactPanel,
} from '../../store/reducers/artifactsReducer';
import { AppDispatch } from '../../store/store';
import { ArtifactItem, MentorBase } from '../../types/mentor';

export const useArtifacts = () => {
  const state = useSelector(getArtifactsState);
  const dispatch: AppDispatch = useDispatch();

  return {
    ...state,
    setArtifactsList: (list: ArtifactItem[]) =>
      dispatch(setArtifactsList(list)),
    toggleArtifactPanel: (isOpen: boolean) =>
      dispatch(toggleArtifactPanel(isOpen)),
    setSummarization: (summary: string) => dispatch(setSummarization(summary)),
    setSuggestedMentors: (mentors: MentorBase[] | null) =>
      dispatch(setSuggestedMentors(mentors)),
  };
};
